import useSWR from "swr";
import { createHeyLightAdapterAxiosClient } from "./createHeyLightAdapterAxiosClient.ts";
export enum Currency {
  Eur = "EUR",
}

type MoneyDTO = {
  amount: number;
  currency: Currency;
};
export type HeyLightProductDTO = {
  id: string;
  priceInCents: MoneyDTO;
  productName: string;
  internalProductName: string;
  peopleCount: number;
};
export function useHeyLightProductById(productId: string) {
  const { data, isLoading } = useSWR(`/product/${productId}`, async (url) => {
    const { data } =
      await createHeyLightAdapterAxiosClient().get<HeyLightProductDTO>(url);
    return data;
  });

  return {
    product: data,
    isLoading,
  };
}
